import { render } from "./UsersSuperAdmin.vue?vue&type=template&id=6382e7c7&scoped=true&lang=pug"
import script from "./UsersSuperAdmin.vue?vue&type=script&lang=js"
export * from "./UsersSuperAdmin.vue?vue&type=script&lang=js"

import "./UsersSuperAdmin.vue?vue&type=style&index=0&id=6382e7c7&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6382e7c7"]])

export default __exports__